import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const SectionPagerStyle = styled('nav')`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 24px;

    .btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        min-height: 40px;
        padding: 8px 16px;
        border-radius: 6px;
        border: 1px solid transparent;
        ${typography.buttonMd}
        text-decoration-line: none;
        transition: background-color 0.2s, border-color 0.2s;
    }

    .btn-back {
        background: var(--sand-100);
        border-color: var(--sand-700);
        color: var(--sand-700);

        &:hover {
            background: var(--sand-300);
            color: var(--sand-700);
        }
    }

    .btn-primary {
        flex: 1 1 auto;
        background: var(--burgundy-800);
        border-color: var(--burgundy-800);
        color: var(--sand-100);

        &:hover {
            background: var(--burgundy-700);
            border-color: var(--burgundy-700);
            color: var(--sand-100);
        }
    }

    .btn-next span {
        flex: 1 1 auto;
        text-align: center;
    }

    @media print {
        display: none;
    }
`;

export default SectionPagerStyle;
